<template>
  <div class="intro-page">
    <div class="a item" @click="handleTo(1)"></div>
    <div class="b item" @click="handleTo(2)"></div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  methods: {
    handleTo (type) {
      if (type === 1) {
        this.$router.push('/580Introduce?id=1')
      } else if (type === 2) {
        this.$router.push('/699Introduce?id=1')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.intro-page{
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.item{
  width: 100%;
  height: 50vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.a{
  background-image: url(../assets/images/intro/m580.png);
}
.b{
  background-image: url(../assets/images/intro/m699.png);
}
</style>